import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
} from "reactstrap";

import {
    FiArrowRight,
    FiCheckCircle,
    FiCode,
    FiUsers,
    FiBriefcase,
    FiBookOpen,
    FiMonitor,
    FiMapPin,
    FiTarget,
    FiTrendingUp,
    FiSettings,
    FiAward,
} from "react-icons/fi";

import "./AboutPage.css";

import SEO from "../../components/common/seo/SEO";


function AboutPage() {
    return (
        <>

            <SEO
                title="About FeesWorth | Professional CAD, AI & Technology Training"
                description="Learn more about FeesWorth, a professional training platform offering practical CAD customization, CAD automation, AI, programming and technology training for students and working professionals."
                keywords="FeesWorth, about FeesWorth, CAD training, CAD customization training, CAD automation training, AI training, programming training, corporate training"
                canonical="https://feesworth.com/about"
            />


            <div className="about-page">


                {/* =====================================================
                    HERO SECTION
                ===================================================== */}

                <section className="about-hero">

                    <Container>

                        <div className="about-hero-content">

                            <span className="about-hero-badge">
                                About FeesWorth
                            </span>

                            <h1>
                                Learn. Build. <span>Grow.</span>
                            </h1>

                            <p>
                                Practical technology training designed to help
                                students, engineers and working professionals
                                build real-world skills and advance their
                                careers.
                            </p>

                            <div className="about-hero-actions">

                                <Button
                                    href="/best-online-courses"
                                    className="about-primary-btn"
                                >
                                    Explore Our Courses
                                    <FiArrowRight />
                                </Button>

                                <Button
                                    href="/contact"
                                    className="about-secondary-btn"
                                >
                                    Contact Us
                                </Button>

                            </div>

                        </div>

                    </Container>

                </section>


                {/* =====================================================
                    WHO WE ARE
                ===================================================== */}

                <section className="about-section about-who-section">

                    <Container>

                        <Row className="align-items-center g-5">

                            <Col lg="6">

                                <div className="about-section-heading">

                                    <span className="about-label">
                                        Who We Are
                                    </span>

                                    <h2>
                                        Building Skills for the
                                        <span> Real World</span>
                                    </h2>

                                </div>

                                <p className="about-main-text">

                                    FeesWorth is a professional online training
                                    platform focused on practical,
                                    industry-oriented technology education.

                                </p>

                                <p className="about-main-text">

                                    We help students, engineers, designers and
                                    working professionals develop skills that
                                    can be applied directly to real-world
                                    projects and engineering workflows.

                                </p>

                                <p className="about-main-text">

                                    Our training programs cover areas such as
                                    CAD Customization, CAD Automation, AI,
                                    Machine Learning, Python, programming and
                                    other technology-focused skills.

                                </p>


                                <div className="about-check-list">

                                    <div>
                                        <FiCheckCircle />
                                        <span>
                                            Practical and industry-focused
                                            training
                                        </span>
                                    </div>

                                    <div>
                                        <FiCheckCircle />
                                        <span>
                                            Real-world projects and examples
                                        </span>
                                    </div>

                                    <div>
                                        <FiCheckCircle />
                                        <span>
                                            Training for students and
                                            professionals
                                        </span>
                                    </div>

                                    <div>
                                        <FiCheckCircle />
                                        <span>
                                            Online and interactive learning
                                        </span>
                                    </div>

                                </div>

                            </Col>


                            <Col lg="6">

                                <div className="about-visual-card">

                                    <div className="about-visual-grid">

                                        <div className="about-stat-card">

                                            <div className="about-stat-icon">
                                                <FiBookOpen />
                                            </div>

                                            <strong>
                                                Practical
                                            </strong>

                                            <span>
                                                Learning
                                            </span>

                                        </div>


                                        <div className="about-stat-card">

                                            <div className="about-stat-icon">
                                                <FiCode />
                                            </div>

                                            <strong>
                                                Technology
                                            </strong>

                                            <span>
                                                Skills
                                            </span>

                                        </div>


                                        <div className="about-stat-card">

                                            <div className="about-stat-icon">
                                                <FiBriefcase />
                                            </div>

                                            <strong>
                                                Industry
                                            </strong>

                                            <span>
                                                Projects
                                            </span>

                                        </div>


                                        <div className="about-stat-card">

                                            <div className="about-stat-icon">
                                                <FiTrendingUp />
                                            </div>

                                            <strong>
                                                Career
                                            </strong>

                                            <span>
                                                Growth
                                            </span>

                                        </div>

                                    </div>

                                </div>

                            </Col>

                        </Row>

                    </Container>

                </section>


                {/* =====================================================
                    WHAT WE DO
                ===================================================== */}

                <section className="about-section about-services-section">

                    <Container>

                        <div className="about-centered-heading">

                            <span className="about-label">
                                What We Do
                            </span>

                            <h2>
                                Training Designed Around
                                <span> Practical Skills</span>
                            </h2>

                            <p>
                                Our courses focus on helping learners understand
                                technology through practical examples,
                                projects and real-world applications.
                            </p>

                        </div>


                        <Row className="g-4 mt-3">

                            <Col lg="4" md="6">

                                <Card className="about-service-card">

                                    <CardBody>

                                        <div className="about-service-icon">
                                            <FiSettings />
                                        </div>

                                        <h3>
                                            CAD Customization
                                        </h3>

                                        <p>
                                            Learn how to customize CAD
                                            platforms and build solutions
                                            using programming, APIs, macros
                                            and development tools.
                                        </p>

                                        <a
                                            href="/cad-customization-courses"
                                            className="about-card-link"
                                        >
                                            Explore CAD Training
                                            <FiArrowRight />
                                        </a>

                                    </CardBody>

                                </Card>

                            </Col>


                            <Col lg="4" md="6">

                                <Card className="about-service-card">

                                    <CardBody>

                                        <div className="about-service-icon about-icon-orange">
                                            <FiCode />
                                        </div>

                                        <h3>
                                            Programming & AI
                                        </h3>

                                        <p>
                                            Build programming, AI, machine
                                            learning and data-related skills
                                            through structured practical
                                            training.
                                        </p>

                                        <a
                                            href="/best-online-courses"
                                            className="about-card-link"
                                        >
                                            Explore Courses
                                            <FiArrowRight />
                                        </a>

                                    </CardBody>

                                </Card>

                            </Col>


                            <Col lg="4" md="6">

                                <Card className="about-service-card">

                                    <CardBody>

                                        <div className="about-service-icon about-icon-purple">
                                            <FiBriefcase />
                                        </div>

                                        <h3>
                                            Corporate Training
                                        </h3>

                                        <p>
                                            Specialized training programs for
                                            organizations looking to improve
                                            technical skills and productivity.
                                        </p>

                                        <a
                                            href="/contact"
                                            className="about-card-link"
                                        >
                                            Discuss Training
                                            <FiArrowRight />
                                        </a>

                                    </CardBody>

                                </Card>

                            </Col>

                        </Row>

                    </Container>

                </section>


                {/* =====================================================
                    TRAINING APPROACH
                ===================================================== */}

                <section className="about-section about-approach-section">

                    <Container>

                        <Row className="align-items-center g-5">

                            <Col lg="5">

                                <div className="about-approach-heading">

                                    <span className="about-label">
                                        Our Approach
                                    </span>

                                    <h2>
                                        Learn Skills That You Can
                                        <span> Actually Use</span>
                                    </h2>

                                    <p>
                                        We believe technical training should
                                        go beyond theory. Our programs are
                                        structured to connect concepts with
                                        practical applications.
                                    </p>

                                </div>

                            </Col>


                            <Col lg="7">

                                <div className="about-process">

                                    <div className="about-process-item">

                                        <div className="about-process-number">
                                            01
                                        </div>

                                        <div>
                                            <h3>
                                                Learn the Fundamentals
                                            </h3>

                                            <p>
                                                Understand the core concepts,
                                                tools and technologies before
                                                moving into advanced topics.
                                            </p>
                                        </div>

                                    </div>


                                    <div className="about-process-item">

                                        <div className="about-process-number">
                                            02
                                        </div>

                                        <div>
                                            <h3>
                                                Practice with Real Examples
                                            </h3>

                                            <p>
                                                Apply concepts through practical
                                                exercises and industry-oriented
                                                examples.
                                            </p>
                                        </div>

                                    </div>


                                    <div className="about-process-item">

                                        <div className="about-process-number">
                                            03
                                        </div>

                                        <div>
                                            <h3>
                                                Build Projects
                                            </h3>

                                            <p>
                                                Work on practical projects that
                                                help transform theoretical
                                                knowledge into usable skills.
                                            </p>

                                        </div>

                                    </div>


                                    <div className="about-process-item">

                                        <div className="about-process-number">
                                            04
                                        </div>

                                        <div>
                                            <h3>
                                                Apply Skills Professionally
                                            </h3>

                                            <p>
                                                Develop the confidence to use
                                                your skills in professional
                                                projects and career opportunities.
                                            </p>

                                        </div>

                                    </div>

                                </div>

                            </Col>

                        </Row>

                    </Container>

                </section>


                {/* =====================================================
                    WHY FEESWORTH
                ===================================================== */}

                <section className="about-section about-why-section">

                    <Container>

                        <div className="about-centered-heading">

                            <span className="about-label">
                                Why FeesWorth
                            </span>

                            <h2>
                                More Than Just
                                <span> Online Courses</span>
                            </h2>

                            <p>
                                Our focus is on helping learners develop
                                practical skills that can create long-term
                                professional value.
                            </p>

                        </div>


                        <Row className="g-4 mt-3">

                            <Col lg="3" md="6">

                                <div className="about-why-card">

                                    <FiMonitor />

                                    <h3>
                                        Live Learning
                                    </h3>

                                    <p>
                                        Interactive online sessions designed
                                        for better understanding and discussion.
                                    </p>

                                </div>

                            </Col>


                            <Col lg="3" md="6">

                                <div className="about-why-card">

                                    <FiCode />

                                    <h3>
                                        Practical Skills
                                    </h3>

                                    <p>
                                        Focus on coding, tools, APIs and
                                        practical technical implementation.
                                    </p>

                                </div>

                            </Col>


                            <Col lg="3" md="6">

                                <div className="about-why-card">

                                    <FiBriefcase />

                                    <h3>
                                        Industry Focus
                                    </h3>

                                    <p>
                                        Training designed around professional
                                        workflows and real-world applications.
                                    </p>

                                </div>

                            </Col>


                            <Col lg="3" md="6">

                                <div className="about-why-card">

                                    <FiAward />

                                    <h3>
                                        Career Growth
                                    </h3>

                                    <p>
                                        Build technical capabilities that can
                                        support your long-term career development.
                                    </p>

                                </div>

                            </Col>

                        </Row>

                    </Container>

                </section>


                {/* =====================================================
                    CORPORATE TRAINING
                ===================================================== */}

                <section className="about-corporate-section">

                    <Container>

                        <Row className="align-items-center g-5">

                            <Col lg="7">

                                <span className="about-label about-label-light">
                                    Corporate Training
                                </span>

                                <h2>
                                    Helping Teams Build
                                    <span> Specialized Technical Skills</span>
                                </h2>

                                <p>
                                    FeesWorth also provides specialized
                                    corporate training programs designed
                                    around the technical requirements of
                                    organizations.
                                </p>

                                <p>
                                    Our CAD Customization and Automation
                                    training has been conducted for companies
                                    including Molex, Valeo, Bradken, Mold
                                    Masters, Sacha Engineering and others.
                                </p>


                                <Button
                                    href="/contact"
                                    className="about-light-btn"
                                >
                                    Discuss Corporate Training
                                    <FiArrowRight />
                                </Button>

                            </Col>


                            <Col lg="5">

                                <div className="about-corporate-card">

                                    <FiUsers />

                                    <strong>
                                        Corporate Learning
                                    </strong>

                                    <span>
                                        Customized technical training
                                        programs for teams and organizations.
                                    </span>

                                </div>

                            </Col>

                        </Row>

                    </Container>

                </section>


                {/* =====================================================
                    CAREER / STUDENT SUCCESS
                ===================================================== */}

                <section className="about-section about-success-section">

                    <Container>

                        <Row className="align-items-center g-5">

                            <Col lg="6">

                                <div className="about-success-card">

                                    <div className="about-success-icon">
                                        <FiTrendingUp />
                                    </div>

                                    <div className="about-success-stat">
                                        4X – 5X
                                    </div>

                                    <span>
                                        Salary growth reported by some
                                        learners after transitioning into
                                        specialized technical roles.
                                    </span>

                                </div>

                            </Col>


                            <Col lg="6">

                                <span className="about-label">
                                    Student Success
                                </span>

                                <h2>
                                    Skills That Open New
                                    <span> Career Opportunities</span>
                                </h2>

                                <p>
                                    Our students have progressed into
                                    technology and engineering roles across
                                    organizations such as Honeywell, Autodesk,
                                    TCS, Cognizant, Tata Technologies,
                                    L&T Technology Services, ITC Infotech,
                                    Tech Mahindra, Ford, Kennametal and others.
                                </p>

                                <p>
                                    The goal of our training is not simply to
                                    complete a course, but to help learners
                                    develop practical skills that they can
                                    continue to use throughout their careers.
                                </p>

                            </Col>

                        </Row>

                    </Container>

                </section>


                {/* =====================================================
                    LOCATION
                ===================================================== */}

                <section className="about-location-section">

                    <Container>

                        <Row className="g-4">

                            <Col lg="6">

                                <div className="about-location-card">

                                    <div className="about-location-icon">
                                        <FiMapPin />
                                    </div>

                                    <div>

                                        <span className="about-location-label">
                                            Our Location
                                        </span>

                                        <h3>
                                            FeesWorth
                                        </h3>

                                        <p>
                                            2nd Floor,
                                            <br />
                                            DSU Innovation Campus,
                                            <br />
                                            Kudlu Gate, Bangalore,
                                            <br />
                                            India - 560068
                                        </p>

                                    </div>

                                </div>

                            </Col>


                            <Col lg="6">

                                <div className="about-location-card">

                                    <div className="about-location-icon about-location-orange">
                                        <FiTarget />
                                    </div>

                                    <div>

                                        <span className="about-location-label">
                                            Our Mission
                                        </span>

                                        <h3>
                                            Practical Skills. Better Careers.
                                        </h3>

                                        <p>
                                            To make practical and
                                            industry-oriented technology
                                            education accessible to students,
                                            engineers and working professionals.
                                        </p>

                                    </div>

                                </div>

                            </Col>

                        </Row>

                    </Container>

                </section>


                {/* =====================================================
                    FINAL CTA
                ===================================================== */}

                <section className="about-cta-section">

                    <Container>

                        <div className="about-cta-content">

                            <span>
                                Start Learning With FeesWorth
                            </span>

                            <h2>
                                Build Skills That Move Your Career Forward
                            </h2>

                            <p>
                                Explore our courses or speak with our team
                                about the right training program for you.
                            </p>


                            <div className="about-cta-buttons">

                                <Button
                                    href="/best-online-courses"
                                    className="about-cta-primary"
                                >
                                    Explore Courses
                                    <FiArrowRight />
                                </Button>

                                <Button
                                    href="/contact"
                                    className="about-cta-secondary"
                                >
                                    Contact FeesWorth
                                </Button>

                            </div>

                        </div>

                    </Container>

                </section>


            </div>

        </>
    );
}


export default AboutPage;